import { LoggerHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$helpers';

export class SharepointCommunicationHelper {
	public static init = ({ onChangeSimulatorView }: any) => {
		LoggerHelper.log('SharepointCommunicationHelper', 'SharepointCommunicationHelper >> init >>');

		(window as any).onChangeSimulatorView = onChangeSimulatorView;
	};
}
